import { Grid } from '@chakra-ui/react';
import i18n from 'i18next';
import { map, property } from 'lodash';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import { PartialStateCode, User } from '../../../api/types';
import { statusCodes as statusCodesColors } from '../../../foundations/theme';
import { getEmptyStateChart } from '../../../helpers/chartHelper';
import { Analytics } from '../../../hooks/useAnalyticsQuery';

const getUserChart = (data: Analytics[], statusCodes: PartialStateCode<string>, users: User[]) => {
  const chartData: object[] = [];
  users.forEach((user) => {
    let objectToPush = {
      label: user?.name,
    };
    // @ts-ignore
    const records = data.filter((obj) => obj.user_id == user?.id);

    records.forEach((record) => {
      // @ts-ignore
      objectToPush[`${user?.name}-${statusCodes[record?.status]}`] = record?.total;
    });

    chartData.push(objectToPush);
  });
  return chartData;
};

const renderTranslatedTooltipText = (value: string, name: string, statusKey: string, users: Array<User>) => {
  let returnValue: boolean | string[] = false;
  const statusLabel = name.split('-')[1];
  users.forEach(() => {
    if (i18n.exists(`${statusKey}:status.${statusLabel}.label`)) {
      returnValue = [value, i18n.t(`${statusKey}:status.${statusLabel}.label`)];
    }
  });
  return returnValue;
};
//todo change chart to vertical layout
const UserBarChart = (props: { data: Analytics; users: Array<User>; statusCodes: PartialStateCode<string>; statusKey: string }) => {
  const { data = {}, users = [], statusCodes, statusKey } = props;

  const loadingData = getEmptyStateChart(map(users, property('name')), map(users, property('name')));
  // @ts-ignore
  const chartData = getUserChart(data, statusCodes, users);
  return (
    <Grid>
      <ResponsiveContainer aspect={3.1}>
        <BarChart
          width={500}
          height={300}
          data={chartData.length === 0 ? loadingData : chartData}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
          barSize={10}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="label" />
          {/*   @ts-ignore*/}
          <YAxis domain={[0, (dataMax) => dataMax + dataMax * 0.1]} />
          <Tooltip
            // @ts-ignore
            formatter={(
              value,
              name, // @ts-ignore
            ) => renderTranslatedTooltipText(value, name, statusKey, users)}
          />

          {users.map((user) => {
            return Object.values(statusCodes).map((status) => {
              return (
                <Bar
                  key={user?.id + status}
                  stackId={user?.name}
                  dataKey={`${user?.name}-${status}`}
                  // @ts-ignore
                  fill={statusCodesColors[status]?.base || 'gray'}
                />
              );
            });
          })}
        </BarChart>
      </ResponsiveContainer>
    </Grid>
  );
};

export default UserBarChart;
